import {
  Vue,
  App,
  installStore,
  installValidate,
  i18n,
  routerProducts,
  storeProducts,
  focusVisible,
} from '@/import'

import '@/scss/fonts.scss'

window.landing = function (el, config = {}) {
  Promise.all([
    Vue(),
    App(),
    installStore(),
    installValidate(),
    i18n(),
    routerProducts(),
    storeProducts(),
    focusVisible(),
  ]).then(([Vue, App, installStore, installValidate, i18n, router, store]) => {
    Vue.use(installStore)
    Vue.use(installValidate)

    new Vue({
      i18n,
      store,
      router,
      render: h => h(App, { attrs: { config } }),
    }).$mount(el)
  })
}
